let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5SiDe"), load("bMgpg"), load("iBa9k"), load("l0PqP"), load("bKQuS"), load("aZinD"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));